(function () {
  'use strict';
  function addBusinessDays(dateKey, days) {
    const date = new Date(dateKey + 'T12:00:00Z');
    while (days > 0) { date.setUTCDate(date.getUTCDate() + 1); if (![0, 6].includes(date.getUTCDay())) days--; }
    return date.toISOString().slice(0, 10);
  }
  function preparationDays(orderDate, variantId) {
    const override = typeof window !== 'undefined' && window.InspireLeadTimes?.variants?.[String(variantId)];
    if (override === 3 || override === 5) return override;
    return [0, 3, 4, 5, 6].includes(new Date(orderDate + 'T12:00:00Z').getUTCDay()) ? 2 : 3;
  }
  function timeline(orderDate, variantId) {
    const ready = addBusinessDays(orderDate, preparationDays(orderDate, variantId));
    return { ordered: orderDate, ready, earliest: addBusinessDays(ready, 1), latest: addBusinessDays(ready, 5) };
  }
  const format = key => new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric', timeZone: 'UTC' }).format(new Date(key + 'T12:00:00Z'));
  function today(zone = 'America/Los_Angeles', now = new Date()) {
    const p = Object.fromEntries(new Intl.DateTimeFormat('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', timeZone: zone }).formatToParts(now).map(x => [x.type, x.value]));
    return `${p.year}-${p.month}-${p.day}`;
  }
  function current(zone, now, variantId) {
    const dates = timeline(today(zone, now), variantId);
    return { ...dates, value: format(dates.earliest) + ' and ' + format(dates.latest), display: format(dates.earliest) + ' \u2013 ' + format(dates.latest) };
  }
  const api = { addBusinessDays, preparationDays, timeline, format, today, current };
  if (typeof module !== 'undefined') module.exports = api;
  if (typeof window !== 'undefined') window.InspireDeliveryPolicy = api;
})();
